const QuestionBank = [
  "Q: What material does this program teach?",
  "A: Students will learn introductory coding skills like block code and calling functions, eventually shifting to line code and if-statement logic. These coding activities will cultivate students’ reasoning and problem-solving logic in an engaging, fun way. ",
  "Q: What is the format of the classes?",
  "A: Classes are led by high-schoolers with in-depth experience in computer science. They will assign activities on a platform (Code.org or CodeHS, depending on the school level) for the students and guide them through new concepts. For students who have extensive experience, we will also be offering personalized projects.",
  "Q: Is any experience necessary?",
  "A: Our program is beginner-friendly and no experience is required.",
  "Q: How often are the classes?",
  "A: Classes will run once a week (excluding breaks) throughout the rest of the school year.",
  "Q: What times are the classes?",
  "A: Class times will vary across schools. Contact us or the school for program times.",
  "Q: Do parents need to be present to watch their kids?",
  "A: Unless a parent requests to supervise their child during the program, guardians do not need to attend the classes. There will be certified adults from each school to oversee the activity.",
  "Q: How long are the classes?",
  "A: Classes will be one hour each per week.",
  "Q: Are volunteer positions needed?",
  "A: Yes! We welcome any volunteers who are in high school and have computer science experience. Navigate our join page to see a volunteer form."
]

export default QuestionBank;